import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';

import { usePersonalDetails } from 'src/components/Profile/PersonalDetails/data';

export const useAuthenticationStatus = () => {
  const { personalDetails, loading } = usePersonalDetails();

  if (loading) {
    return AUTHENTICATION_TYPES.AUTH_PENDING;
  }
  if (personalDetails?._id) {
    return AUTHENTICATION_TYPES.AUTHENTICATED;
  }
  return AUTHENTICATION_TYPES.UNAUTHENTICATED;
};
